import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 188,
	height: 204,
	viewBox: "0 0 188 204",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M127 111V101.5C127 98.7386 124.761 96.5 122 96.5H84.0711C82.745 96.5 81.4732 95.9732 80.5355 95.0355L74.4645 88.9645C73.5268 88.0268 72.255 87.5 70.9289 87.5H38.5C35.7386 87.5 33.5 89.7386 33.5 92.5V158.654C33.5 161.054 35.4458 163 37.846 163C39.7271 163 41.3946 161.79 41.9778 160.001L54.875 120.45C55.546 118.392 57.4645 117 59.6287 117H135.11C138.51 117 140.918 120.319 139.864 123.55L128.125 159.55C127.454 161.608 125.536 163 123.371 163H50.5",
			stroke: "#72A11A",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69 79V7C69 4.23858 71.2386 2 74 2H111.929C113.255 2 114.527 2.52678 115.464 3.46447L130.536 18.5355C131.473 19.4732 132 20.745 132 22.0711V83C132 85.7614 129.761 88 127 88H86.5M110 10V18C110 20.7614 112.239 23 115 23H124.5",
			stroke: "#72A11A",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.411 75.797C164.023 75.0651 163.115 74.7865 162.383 75.1746C161.651 75.5627 161.372 76.4707 161.76 77.2025L163.086 76.4998L164.411 75.797ZM47.9397 41.8741C48.1722 41.079 47.7161 40.2459 46.921 40.0134L33.9636 36.2244C33.1685 35.9919 32.3354 36.448 32.1029 37.2432C31.8704 38.0383 32.3265 38.8714 33.1216 39.1039L44.6393 42.4718L41.2713 53.9895C41.0388 54.7846 41.4949 55.6177 42.29 55.8502C43.0852 56.0827 43.9182 55.6266 44.1507 54.8315L47.9397 41.8741ZM173 116.5H171.5C171.5 162.892 133.892 200.5 87.5 200.5V202V203.5C135.549 203.5 174.5 164.549 174.5 116.5H173ZM87.5 202V200.5C41.1081 200.5 3.5 162.892 3.5 116.5H2H0.5C0.5 164.549 39.4512 203.5 87.5 203.5V202ZM163.086 76.4998L161.76 77.2025C167.978 88.9267 171.5 102.3 171.5 116.5H173H174.5C174.5 101.798 170.852 87.9436 164.411 75.797L163.086 76.4998ZM2 116.5H3.5C3.5 84.7054 21.1637 57.0345 47.2203 42.7688L46.5 41.4531L45.7797 40.1374C18.8003 54.9083 0.5 83.5658 0.5 116.5H2Z",
			fill: "#313131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M186 48.5C186 59.8218 176.822 69 165.5 69C154.178 69 145 59.8218 145 48.5C145 37.1782 154.178 28 165.5 28C168.532 28 171.41 28.6583 174 29.8397",
			stroke: "#313131",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158 43.5L164.089 52.8368C164.804 53.9321 166.36 54.0585 167.241 53.0928L186.5 32",
			stroke: "#72A11A",
			strokeWidth: 3,
			strokeLinecap: "round"
		})
	]
});
export default SvgEmptyProjects;
